import { observable, action, makeObservable, runInAction } from 'mobx';
import { getInviteInfo, submitInviteInfo } from '../api/student_invite';
import message from '@/components/Toast';

class Login {
  constructor() {
    makeObservable(this);
  }
  @observable
  mode = 'invite'; //success

  @action
  setMode = (v) => {
    this.mode = v;
  };

  @observable
  inviteInfo = {};

  getInviteInfo = async (id, tenantId) => {
    const { data, msg, code } = await getInviteInfo(id, {
      headers: {
        TenantId: tenantId
      }
    });
    if (code === '00000') {
      runInAction(() => {
        this.inviteInfo = data;
      });
    } else if (code === 'A1111') {
      runInAction(() => {
        this.inviteInfo = { invitation_status: 'A1111' };
      });
    } else {
      runInAction(() => {
        this.inviteInfo = {};
      });
      return message.error(msg);
    }
  };

  submitInviteInfo = async (id, params, tenantId) => {
    const { msg, code } = await submitInviteInfo(id, params, {
      headers: {
        TenantId: tenantId
      }
    });
    if (code === '00000') {
      runInAction(() => {
        this.mode = 'success';
        this.inviteInfo.phone_number = params.phone_number;
      });
    } else {
      return message.error(msg);
    }
  };
}
export default new Login();
